<template>
    <div class="col-md-6 col-lg-3">
      <div :class="['widget-small', color, 'coloured-icon']">
        <i :class="['icon', icon, 'fs-1']"></i>
        <div class="info">
          <h4>{{ title }}</h4>
          <p><b>{{ value }}</b></p>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  defineProps({
    title: String,
    value: [String, Number],
    icon: String,
    color: String, // primary, info, warning, danger
  });
  </script>
  